module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4CAIAAAC2BqGFAAABJ0lEQVR42uzcsW6CQBjA8ba55UgYu7RPAU3aF2zCbvQldDDRwbe6Cy7g5s6iDkKQ33+8wU9+IR8ThK/P7zc9vw8EoEELNGjQAg1aoEGDFmjQAg0atECDFmjQoAUatECDBi3QoAUaNGiBfpHCVIN3+21VVSMPTSn91n/Lgo4xxiKOPLS4FFaHHS3QHoa3a9tzzvmBPxpCWZaDw67r+767/0dyylNd7/tcXn+rf+rj6TA4bP6b9WpjdQg0aNACDVqgQYMWaNACDRq0QIMWaNCgBRq0QIMGLdCgBRo0aIEGLdCgQQs0aIEGDVqgQQs0aNACDVrz+YyEO1qgQYMWaNACDRq0QIMWaNCgBRq0QIMGLdCgBRo0aIEGLdCgQQs0aIEGvaiuAQAA//8VYR2GjdLQhwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/the-telegraph.png
// module id = pe9U
// module chunks = 0